import { IconComponent } from './types';

const FieldBoundaryIcon: IconComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    viewBox="0 0 12 12"
    fill="none"
    {...props}
  >
    <path
      stroke="currentColor"
      d="M6.17.5h5.33v5h-3v6h-8V4.83L6.17.5ZM5.5 11V1M0 7.5h9"
    />
  </svg>
);
export default FieldBoundaryIcon;
